import { c as _c } from "react/compiler-runtime";
import React from "react";
import { RadioButtonGroup } from "../../../../shared/components/RadioButton/RadioButtonGroup";
import { PaymentMethod } from "../../../../shared/components/Widget/types/Enums";
import { PaymentMethodString } from "../hooks/useFundraiserForm";
interface PaymentMethodSelectorProps {
  methods: Array<{
    _type: string;
    selector_text: string | null;
    single_button_text: string | null;
    recurring_button_text: string | null;
    button_text: string | null;
  }>;
  selected: PaymentMethodString;
  onSelect: (method: PaymentMethodString) => void;
}
export const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = t0 => {
  const $ = _c(10);
  const {
    methods,
    selected,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== methods) {
    t1 = methods.map(_temp);
    $[0] = methods;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const getSelectedValue = _temp2;
  const getMethodKey = _temp3;
  let t2;
  if ($[2] !== selected) {
    t2 = getSelectedValue(selected);
    $[2] = selected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedValue = t2;
  let t3;
  if ($[4] !== onSelect) {
    t3 = value_0 => {
      onSelect(getMethodKey(value_0));
    };
    $[4] = onSelect;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== options || $[7] !== selectedValue || $[8] !== t3) {
    t4 = <RadioButtonGroup options={options} selected={selectedValue} onSelect={t3} />;
    $[6] = options;
    $[7] = selectedValue;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp(method) {
  const methodType = method._type;
  let paymentMethodValue = PaymentMethod.BANK;
  const dataCy = `fundraiser-method-${methodType}`;
  if (methodType === "vipps") {
    paymentMethodValue = PaymentMethod.VIPPS;
  } else {
    if (methodType === "bank") {
      paymentMethodValue = PaymentMethod.BANK;
    } else {
      if (methodType === "quickpay_card") {
        paymentMethodValue = PaymentMethod.QUICKPAY_CARD;
      } else {
        if (methodType === "quickpay_mobilepay") {
          paymentMethodValue = PaymentMethod.QUICKPACK_MOBILEPAY;
        } else {
          if (methodType === "dkbank") {
            paymentMethodValue = PaymentMethod.DKBANK;
          }
        }
      }
    }
  }
  return {
    title: method.selector_text || methodType,
    value: paymentMethodValue,
    data_cy: dataCy
  };
}
function _temp2(selected_0) {
  if (selected_0 === "bank") {
    return PaymentMethod.BANK;
  }
  if (selected_0 === "vipps") {
    return PaymentMethod.VIPPS;
  }
  if (selected_0 === "quickpay_card") {
    return PaymentMethod.QUICKPAY_CARD;
  }
  if (selected_0 === "quickpay_mobilepay") {
    return PaymentMethod.QUICKPACK_MOBILEPAY;
  }
  if (selected_0 === "dkbank") {
    return PaymentMethod.DKBANK;
  }
  return PaymentMethod.VIPPS;
}
function _temp3(value) {
  if (value === PaymentMethod.BANK) {
    return "bank";
  }
  if (value === PaymentMethod.VIPPS) {
    return "vipps";
  }
  if (value === PaymentMethod.QUICKPAY_CARD) {
    return "quickpay_card";
  }
  if (value === PaymentMethod.QUICKPACK_MOBILEPAY) {
    return "quickpay_mobilepay";
  }
  if (value === PaymentMethod.DKBANK) {
    return "dkbank";
  }
  return "vipps";
}